module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[67]554.7ef0233.woff2";